import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-data-mining-table',
  templateUrl: './data-mining-table.component.html',
  styleUrls: ['./data-mining-table.component.css']
})
export class DataMiningTableComponent implements OnInit {
    p2StatSourceKeyno;

    levelNo;

    public setting?: Setting;

    public selectListColumnNames: ColumnNameItem[] = [];

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2StatSourceKeyno = this.stateService.getStateParams()['p2_statsource_keyno'];
        this.levelNo = this.stateService.getStateParams()['level_no'];
    }

    private async loadSetting() {
        if (!!this.p2StatSourceKeyno && !!this.levelNo) {
            this.setting = (await this.datatask.Post(1968, {
                p2_statsource_keyno: this.p2StatSourceKeyno,
                level_no: this.levelNo
            }))[0];
        }
    }

    private async loadColumnNames() {
        if (!!this.p2StatSourceKeyno && !!this.levelNo) {
            this.selectListColumnNames = await this.datatask.Post(1970, {
                p2_statsource_keyno: this.p2StatSourceKeyno,
                level_no: this.levelNo
            });
        }
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.setting.view_id).setLoadDataFunction({ method: this.setting.p2_datatask_keyno, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'column_colname':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadColumnNames();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    view_id: string;
    p2_datatask_keyno: number;
    grouping_colname: string;
    column_colname: string;
    filterinfo: string;
}

interface ColumnNameItem {
    column_colname: string;
    column_colname_translated: string;
    orderby: number;
}
